import { StorageService, STORAGE_KEYS } from 'src/app/services/storage.service';
import { Component, inject, Input } from '@angular/core';
import { IconsService } from 'src/app/shared/services/icons.service';

@Component({
  selector: 'app-nav-tenant-bottom',
  template: `
    <nav class="bottom-nav pb-3 pt-4 border-0 shadow d-flex d-sm-none">
      <button class="nav-button" routerLink="/tenant/dashboard">
        <fa-icon [icon]="icons.faHouse"></fa-icon>
      </button>
      <button class="nav-button">
        <fa-icon [icon]="icons.faBellConcierge"></fa-icon>
      </button>
      <button class="nav-button" routerLink="/tenant/profile/{{user?.id}}">
        <fa-icon [icon]="icons.faUser"></fa-icon>
      </button>
      <button class="nav-button" (click)="signOut()">
        <fa-icon [icon]="icons.faArrowRightFromBracket"></fa-icon>
      </button>
    </nav>
  `,
  styles: ``
})
export class NavTenantBottomComponent {
  @Input() user: any;
  roleLS: any = {};
  storageService = inject(StorageService);
  constructor(
    public icons: IconsService
  ) {
    this.roleLS = this.storageService.getItem(STORAGE_KEYS.ROLE)?.role ?? {};
  }

  signOut() {
    let redirect = this.roleLS?.group_id == 3 ? '/user/sign-in' : '/ingresar';
    this.storageService.removeItem(STORAGE_KEYS.TOKEN);
    this.storageService.removeItem(STORAGE_KEYS.USER);
    this.storageService.removeItem(STORAGE_KEYS.PROFILE);
    this.storageService.removeItem(STORAGE_KEYS.AVATAR);
    this.storageService.removeItem(STORAGE_KEYS.PERMISSIONS);
    this.storageService.removeItem(STORAGE_KEYS.ROLE);
    this.storageService.removeItem(STORAGE_KEYS.FCM_TOKEN);
    //
    window.location.href = redirect;
    // window.location.reload();
  }
}
